const unauthorizedRoutes = [
    "login",
    "register",
    "forgotten-password",
    "password/reset",
];

/**
 * @param {string} [prefix]
 * @returns {boolean}
 */
export function isUnauthorizedRoute(prefix = "") {
    for (const route of unauthorizedRoutes) {
        if (window.location.pathname.includes(`${prefix}/${route}`)) {
            return true;
        }
    }
    return false;
}
